module.exports = __webpack_public_path__ + "static/media/bt-stats.8a59f831.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-stats.png
// module id = 688
// module chunks = 0